export const standardFieldIds = [
  'first-name-personal',
  'last-name-personal',
  'email-personal',
  'customer-or-company-name',
  'company-email',
  'company-phone',
  'company-address',
  'company-city',
  'company-state',
  'company-zip',
  'company-ein',
  'company-dba',
  'company-website',
  'supplier-branches',
  'supplier-sales-reps',
  'company-number-of-employees',
  'company-number-of-years-in-business',
  'company-type-options',
  'company-date-of-incorporation',
  'company-state-of-incorporation',
  'company-annual-revenue',
  'dun-&-bradstreet-number',
  'mailing-address',
  'mailing-city',
  'mailing-state',
  'mailing-zip',
  'shipping-address',
  'shipping-city',
  'shipping-state',
  'shipping-zip',
  'nature-of-business',
  'amount-of-credit-requested',
  'business-owner-name',
  'business-owner-title',
  'business-owner-first-name',
  'business-owner-last-name',
  'business-owner-address',
  'business-owner-city',
  'business-owner-state',
  'business-owner-zip',
  'business-owner-social-security-number',
  'business-owner-phone',
  'business-owner-email',
  'statement-file',
  'bank-reference',
  'credit-amount',
  'billing-email',
  'billing-phone',
  'billing-name',
  'billing-contact',
  'purchasing-email',
  'license-number',
  'license-file',
  'tax-exempt-choice',
  'tax-exempt-number',
  'tax-exempt-file',
  'tax-exempt-form',
  'purchase-order-choice',
  'incorporation-state',
  'epa-number',
  'epa-file',
  'ein-number',
  'ein-file',
  'bonding-option',
  'authorized-agent-field-id',
  'authorized-agent-name',
  'authorized-agent-email',
  'authorized-agent-phone',
  'authorized-agent-address',
  'authorized-agent-city',
  'authorized-agent-state',
  'authorized-agent-zip',
  'authorized-agent-social-security-number',
  'authorized-agent-date-of-birth',
  'authorized-agent-title',
  'authorized-agent-drivers-license',
  'authorized-agent-first-name',
  'authorized-agent-last-name',
  'corporate-guarantor-field-id',
  'corporate-guarantor-name',
  'corporate-guarantor-email',
  'corporate-guarantor-phone',
  'corporate-guarantor-address',
  'corporate-guarantor-city',
  'corporate-guarantor-state',
  'corporate-guarantor-zip',
  'corporate-guarantor-social-security-number',
  'corporate-guarantor-date-of-birth',
  'corporate-guarantor-title',
  'corporate-guarantor-drivers-license',
  'corporate-guarantor-first-name',
  'corporate-guarantor-last-name',
  'guarantor-field-id',
  'guarantor-name',
  'guarantor-email',
  'guarantor-phone',
  'guarantor-address',
  'guarantor-city',
  'guarantor-state',
  'guarantor-zip',
  'guarantor-social-security-number',
  'guarantor-date-of-birth',
  'guarantor-title',
  'guarantor-drivers-license',
  'guarantor-first-name',
  'guarantor-last-name',
  'other-field-id',
  'other-name',
  'other-email',
  'other-phone',
  'other-address',
  'other-city',
  'other-state',
  'other-zip',
  'other-social-security-number',
  'other-date-of-birth',
  'other-title',
  'other-drivers-license',
  'other-first-name',
  'other-last-name',
  'trade-reference-company-name',
  'trade-reference-company-contact-name',
  'trade-reference-company-email',
  'trade-reference-company-phone',
  'trade-reference-company-account-number',
  'trade-reference-company-address',
  'trade-reference-company-city',
  'trade-reference-company-state',
  'trade-reference-company-zip',
  'trade-reference-company-ein',
  'purchase-list',
  'purchase-name',
  'purchase-email',
  'purchase-phone',
  'purchase-address',
  'purchase-city',
  'purchase-state',
  'purchase-zip',
  'purchase-ein',
  'purchase-title',
  'llc-name',
  'llc-type-of-business',
  'llc-address',
  'llc-city',
  'llc-state',
  'llc-zip',
  'llc-contact',
  'llc-email',
  'llc-phone',
  'llc-date-of-incorporation',
  'llc-year-organized',
  'llc-financial-statement',
  'llc-financial-statement-option',
  'llc-president',
  'llc-secretary',
  'llc-treasurer',
  'llc-v-president',
  'llc-tax-number',
  'llc-state-of-incorporation',
  'llc-ein-number',
  'llc-billing-contact',
  'llc-billing-email',
  'llc-billing-phone',
  'llc-sales-tax-number',
  'llc-social-security-number',
  'llc-date-of-birth',
  'llc-percentage-ownership',
  'lp-name',
  'lp-type-of-business',
  'lp-address',
  'lp-city',
  'lp-state',
  'lp-zip',
  'lp-contact',
  'lp-email',
  'lp-phone',
  'lp-date-of-incorporation',
  'lp-year-organized',
  'lp-financial-statement',
  'lp-financial-statement-option',
  'lp-president',
  'lp-secretary',
  'lp-treasurer',
  'lp-v-president',
  'lp-tax-number',
  'lp-state-of-incorporation',
  'lp-ein-number',
  'lp-billing-contact',
  'lp-billing-email',
  'lp-billing-phone',
  'lp-sales-tax-number',
  'lp-social-security-number',
  'lp-date-of-birth',
  'lp-percentage-ownership',
  'government-name',
  'government-type-of-business',
  'government-address',
  'government-city',
  'government-state',
  'government-zip',
  'government-contact',
  'government-email',
  'government-phone',
  'government-date-of-incorporation',
  'government-year-organized',
  'government-financial-statement',
  'government-financial-statement-option',
  'government-president',
  'government-secretary',
  'government-treasurer',
  'government-v-president',
  'government-tax-number',
  'government-state-of-incorporation',
  'government-ein-number',
  'government-billing-contact',
  'government-billing-email',
  'government-billing-phone',
  'government-sales-tax-number',
  'government-social-security-number',
  'government-date-of-birth',
  'llc-percentage-ownership',
  'corporation-name',
  'corporation-type-of-business',
  'corporation-address',
  'corporation-city',
  'corporation-state',
  'corporation-zip',
  'corporation-contact',
  'corporation-email',
  'corporation-phone',
  'corporation-date-of-incorporation',
  'corporation-year-organized',
  'corporation-financial-statement',
  'corporation-financial-statement-option',
  'corporation-president',
  'corporation-secretary',
  'corporation-treasurer',
  'corporation-v-president',
  'corporation-tax-number',
  'corporation-state-of-incorporation',
  'corporation-ein-number',
  'corporation-billing-contact',
  'corporation-billing-email',
  'corporation-billing-phone',
  'corporation-sales-tax-number',
  'corporation-social-security-number',
  'corporation-date-of-birth',
  'corporation-percentage-ownership',
  'partnership-name',
  'partnership-type-of-business',
  'partnership-address',
  'partnership-city',
  'partnership-state',
  'partnership-zip',
  'partnership-contact',
  'partnership-email',
  'partnership-phone',
  'partnership-date-of-birth',
  'partnership-date-of-incorporation',
  'partnership-year-organized',
  'partnership-financial-statement',
  'partnership-percentage-ownership',
  'partnership-spouse-name',
  'partnership-social-security-number',
  'partnership-occupation',
  'sole-proprietor-name',
  'sole-proprietor-type-of-business',
  'sole-proprietor-address',
  'sole-proprietor-city',
  'sole-proprietor-state',
  'sole-proprietor-zip',
  'sole-proprietor-contact',
  'sole-proprietor-email',
  'sole-proprietor-phone',
  'sole-proprietor-date-of-birth',
  'sole-proprietor-date-of-incorporation',
  'sole-proprietor-year-organized',
  'sole-proprietor-financial-statement',
  'sole-proprietor-social-security-number',
  'sole-proprietor-percentage-ownership',
  'sole-proprietor-spouse-name',
  'sole-proprietor-occupation',
  'job-property-owner-name',
  'job-property-owner-email',
  'job-property-owner-phone',
  'job-property-owner-address',
  'job-property-owner-city',
  'job-property-owner-state',
  'job-property-owner-zip',
  'job-name',
  'job-address',
  'job-city',
  'job-state',
  'job-zip',
  'job-contact',
  'job-phone',
  'job-bond-company-name',
  'job-bond-company-address',
  'job-bond-company-city',
  'job-bond-company-state',
  'job-bond-company-zip',
  'job-bond-company-contact',
  'job-bond-number',
  'job-bond-company-email',
  'job-bond-company-phone',
  'job-lot-number',
  'job-financed-by',
  'job-payment-perfomance-bond-choice',
  'job-insurance-company-name',
  'job-insurance-company-address',
  'job-insurance-company-city',
  'job-insurance-company-state',
  'job-insurance-company-zip',
  'job-insurance-company-contact',
  'job-insurance-number',
  'job-insurance-company-email',
  'job-insurance-company-phone',
  'year-established',
  'years-at-present-location',
  'invoice-email',
  'invoice-email-value',
  'bunkrupty-option',
  'priced-packing-choice',
  'sole-proprietor-ein-number',
  'partnership-ein-number',
  'non-profit-ein-number',
  'government-ein-number',
  'other-ein-number',
  // Internal forms (Maintenance Form, Credit Limit Increase Request Form, CASH Account Coversheet).
  'customer-account-number',
  'include-name-change-or-new-choice',
  'existing-customer-or-company-name',
  'company-w-9',
  'name-change-or-acquisition-letter',
  'billing-address-change-choice',
  'billing-address',
  'billing-city',
  'billing-state',
  'billing-zip',
  'physical-addresses-choice',
  'is-new-shipping-address',
  'new-shipping-address',
  'new-shipping-city',
  'new-shipping-state',
  'new-shipping-zip',
  'marketing-segment',
  'is-shipping-address-changes',
  'shipping-account-number',
  'current-credit-limit',
  'oem-mro',
  // External forms' "Internal Information" section (branch / sales reps use supplier-branches and
  // supplier-sales-reps above).
  'shipping-all-at-once',
  'inside-sales-associate',
  'outside-sales-associate',
  'estimated-job-amount',
];

type Field = {
  name: string;
  id: string;
  fromField:
    | 'TEXT'
    | 'NUMBER'
    | 'CURRENCY'
    | 'DATE'
    | 'TEXT_AREA'
    | 'CHECK_BOX'
    | 'FILE'
    | 'OPTION_FIELD'
    | 'DOCUMENT_FIELD'
    | 'INVITE_USER'
    | 'CONDITIONAL_OPTION'
    | 'BANK_REFERENCE'
    | 'TRADE_REFERENCE'
    | 'CONDITIONAL_SELECTED_FIELD'
    | 'STATE_DROPDOWN'
    | 'CHECKBOX_LIST'
    | 'CONDITIONAL_FORM'
    | 'DYNAMIC_FORM_DOCUMENT'
    | 'AUTOFILL_CHECKBOX'
    | 'INTERNAL_SIGNER'
    | 'DROPDOWN';
  isRequired: boolean;
  prefix: string;
  suffix: string;
  alignment?: 'LEFT' | 'RIGHT' | 'CENTER';
  documentText?: string;
  isHashed?: boolean;
  isFieldEmail?: boolean;
  isRow?: boolean;
  optionList?: string;
  optionValueSource?: 'NAME' | 'ERP_ID';
  optionLabelSource?: 'NAME' | 'ERP_ID';
  houseRepsOnly?: boolean;
  houseRepFieldLabel?: string;
  nonHouseRepFieldLabel?: string;
  buttonType?: 'PRIMARY' | 'SECONDARY' | 'TERTIARY';
  fontSize?: string;
  fontWeight?: string;
  spaceHeight?: string;
  whoNeedsToSign?: string;
  fullNameNeeded?: boolean;
  driverLicenseNeeded?: boolean;
  optionType?: string;
  secondaryText?: string;
  status?: 'Pending' | 'Requested' | 'Submitted' | 'Rejected';
  emailDate?: string;
  sendEmail?: boolean;
  signatureGroupName?: string;
  placeHolder?: string;
  type?: 'AUTHORIZED_AGENT' | 'GUARANTOR' | 'OTHER' | 'PERSONAL' | 'CORPORATE_GUARANTOR';
  minimumCreditAmount?: number;
  minimumNumberOfSignatures?: number;
  conditionalOptionFields?: Record<string, any | null>;
  onlyShowPlaidOption?: boolean;
  showIfNotPlaid?: boolean;
  datePickerFormat?: 'FULL_DATE' | 'MONTH_YEAR';
  validationType?: 'NONE' | 'EIN' | 'SSN' | 'PHONE';
  emailValidationType?: 'SINGLE' | 'MULTIPLE';
  maxLength?: number;
  currencyDecimalPlaces?: number;
  labelSubtext?: string | null;
  // Shown only when the source field's answer is one of sourceOptionValues.
  conditionalVisibility?: { sourceFieldId: string; sourceOptionValues: string[] } | null;
};

type SignatureFields = {
  name: string;
  id: string;
  fromField:
    | 'TEXT'
    | 'NUMBER'
    | 'CURRENCY'
    | 'DATE'
    | 'TEXT_AREA'
    | 'CHECK_BOX'
    | 'FILE'
    | 'OPTION_FIELD'
    | 'DOCUMENT_FIELD'
    | 'INVITE_USER'
    | 'CONDITIONAL_OPTION'
    | 'BANK_REFERENCE'
    | 'TRADE_REFERENCE'
    | 'CONDITIONAL_SELECTED_FIELD'
    | 'STATE_DROPDOWN'
    | 'CHECKBOX_LIST'
    | 'CONDITIONAL_FORM'
    | 'DYNAMIC_FORM_DOCUMENT'
    | 'AUTOFILL_CHECKBOX'
    | 'INTERNAL_SIGNER'
    | 'DROPDOWN';
  isRequired: boolean;
  prefix: string;
  suffix: string;
  isHashed?: boolean;
  isFieldEmail?: boolean;
  emailValidationType?: 'SINGLE' | 'MULTIPLE';
  isRow?: boolean;
  index: number;
  columnType?: 'ONE_COLUMN' | 'TWO_COLUMNS' | 'THREE_COLUMNS';
  optionList?: string;
  optionValueSource?: 'NAME' | 'ERP_ID';
  optionLabelSource?: 'NAME' | 'ERP_ID';
  houseRepsOnly?: boolean;
  houseRepFieldLabel?: string;
  nonHouseRepFieldLabel?: string;
};

type FieldDetails = {
  id: string;
  index: number;
  columnType: 'ONE_COLUMN' | 'TWO_COLUMNS' | 'THREE_COLUMNS';
  stepType: 'GROUPED' | 'NOT_GROUPED';
  fields: Field[];
  groupedPosition: number;
};

type StepField = {
  columnType: 'ONE_COLUMN' | 'TWO_COLUMNS' | 'THREE_COLUMNS';
  stepType: 'GROUPED' | 'NOT_GROUPED';
  groupedFields: FieldDetails[];
  unGroupedFields: Field[];
  groupName?: string;
  position: number;
  isFieldArray: boolean;
  moreButtonName?: string;
  minimunNumberOfGroups?: number;
};

type Step = {
  name: string;
  id: string;
  position: number;
  fields: StepField[];
};

export type { Field, SignatureFields, FieldDetails, Step, StepField };

// Every field a template's steps define, grouped by step — the choices for an internal signature
// document's "Visible Credit Application Fields" checklist. Field ids are what end up on the
// application's fieldValues, which is what the backend filters on.
export const getTemplateFieldChoices = (steps: Step[]) =>
  [...steps]
    .sort((a, b) => a.position - b.position)
    .map((step) => {
      const seen = new Set<string>();
      const fields = step.fields
        .flatMap((stepField) => [
          ...(stepField.unGroupedFields ?? []),
          ...(stepField.groupedFields ?? []).flatMap((group) => group.fields ?? []),
        ])
        .filter((field) => field.id && !seen.has(field.id) && seen.add(field.id))
        .map((field) => ({ id: field.id, name: field.name }));
      return { stepName: step.name, fields };
    })
    .filter((group) => group.fields.length > 0);
// A template's label wherever one is picked or listed: its type, then its subsidiary when it has
// one, e.g. "Credit Application - Purvis Industries". Forms go by their name, e.g.
// "External Form - New Ship-To".
export const getCreditApplicationTemplateLabel = (template: {
  applicationType: 'CREDIT_APPLICATION' | 'CASH_APPLICATION' | 'INTERNAL_FORM' | 'EXTERNAL_FORM';
  subsidiaryName?: string | null;
  name?: string | null;
}): string => {
  const formName = template.name?.trim();
  if (template.applicationType === 'EXTERNAL_FORM' && formName) {
    return `External Form - ${formName}`;
  }
  const typeLabel =
    template.applicationType === 'CASH_APPLICATION'
      ? 'COD Application'
      : template.applicationType === 'INTERNAL_FORM'
      ? 'Internal Form'
      : template.applicationType === 'EXTERNAL_FORM'
      ? 'External Form'
      : 'Credit Application';
  const subsidiaryName = template.subsidiaryName?.trim();
  return subsidiaryName ? `${typeLabel} - ${subsidiaryName}` : typeLabel;
};

export function collectIds(data: Step[]): string[] {
  const ids = new Set<string>();

  function traverseFields(fields: Field[]) {
    for (const field of fields ?? []) {
      if (field.fromField !== 'DOCUMENT_FIELD' && field.fromField !== 'BANK_REFERENCE') {
        if (field.id) {
          ids.add(field.id);
        }
      }

      if (field.conditionalOptionFields) {
        Object.values(field.conditionalOptionFields).forEach((option: any) => {
          if (!option) return;

          if (Array.isArray(option.unGroupedFields)) {
            traverseFields(option.unGroupedFields as Field[]);
          }

          if (Array.isArray(option.groupedFields)) {
            for (const group of option.groupedFields as FieldDetails[]) {
              if (Array.isArray(group?.fields)) {
                traverseFields(group.fields);
              }
            }
          }
        });
      }
    }
  }

  for (const step of data ?? []) {
    for (const fieldBlock of step.fields ?? []) {
      if (Array.isArray(fieldBlock.unGroupedFields) && fieldBlock.unGroupedFields.length > 0) {
        traverseFields(fieldBlock.unGroupedFields);
      }
      if (Array.isArray(fieldBlock.groupedFields) && fieldBlock.groupedFields.length > 0) {
        for (const group of fieldBlock.groupedFields) {
          if (Array.isArray(group?.fields)) {
            traverseFields(group.fields);
          }
        }
      }
    }
  }

  return Array.from(ids);
}
